'use strict';
import { ApiRequest } from '../../../../../../../common/api/request';

class QrMismatchService extends ApiRequest {
  constructor(appConfig, uiModalDeclarationService, $q, $http) {
    'ngInject';
    super({
      appConfig,
      uiModalDeclarationService,
      $q,
      $http,
    });
  }

  openModal(data) {
    this.modal = this.uiModalDeclarationService.$uibModal.open({
      component: 'qrMismatchComponent',
      size: 'lg',
      resolve: {
        data: () => {
          return data;
        },
      },
    });

    return this.modal;
  }

  forceUpload() {
    this.modal.close();
  }

  closeModal() {
    this.modal.dismiss();
  }
}

export default QrMismatchService;
